import 'babel-polyfill'
require('es6-promise').polyfill()
require('es6-promise/auto')
require('promise.prototype.finally').shim()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import '@/styles/element/element-variables.scss'

import './permission.js'

import ElementUI from 'element-ui'
import JczhUI from 'jczh-ui'
Vue.use(ElementUI, { size: 'small' })
Vue.use(JczhUI)

import '@/plugin/ant-design.js'

// 控制vue调试工具
const isDebug_mode = process.env.NODE_ENV.indexOf('local') > -1
Vue.config.debug = isDebug_mode
Vue.config.devtools = isDebug_mode
Vue.config.productionTip = isDebug_mode

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
